<template>
  <div class="UnqiueMaps h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="uniqueMap"
      :options="options"
      :func1="this.tier"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/One-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "UniqueMaps",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "mapTier",
          label: "Tier",
          sortable: false,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "1", value: "1", disabled: false },
        { text: "2", value: "2", disabled: false },
        { text: "3", value: "3", disabled: false },
        { text: "4", value: "4", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
        { text: "7", value: "7", disabled: false },
        { text: "8", value: "8", disabled: false },
        { text: "9", value: "9", disabled: false },
        { text: "10", value: "10", disabled: false },
        { text: "11", value: "11", disabled: false },
        { text: "12", value: "12", disabled: false },
        { text: "13", value: "13", disabled: false },
        { text: "14", value: "14", disabled: false },
        { text: "15", value: "15", disabled: false },
        { text: "16", value: "16", disabled: false },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getHref(item) {
      if (item != undefined) {
        if (item.name.includes("Map")) {
          return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"filters":{"type_filters":{"filters":{"category":{"option":"map"}}},"map_filters":{"disabled":false,"filters":{"map_tier":{"min":1,"max":16},"map_shaped":{"option":false},"map_elder":{"option":false},"map_blighted":{"option":false}}}},"type":{"option":"${item.name}"}}}`;
        }
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"name":"${item.name}","stats":[{"type":"and","filters":[]}]},"sort":{"price":"asc"}}`;
      }
    },
    tier(val, item) {
      if (item.mapTier == val) {
        return true;
      }
      return false;
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
